import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { filterFormItemLayout, filterFormGridLayout, filterFormItemStyle, computeButtonColLayout } from '@utils/property';
import { expertLevels } from '../../../utils/constants';

const VISIBLE_FIELD_COUNT = 6;

const EvaluationFilterForm = ({ handleFilterFinish, filter, setFilter }) => {
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(VISIBLE_FIELD_COUNT);
    const { token } = theme.useToken();

    const dispatch = useDispatch();

    const onFinish = values => {
        handleFilterFinish(values);
    };

    const onReset = () => {
        form.resetFields();
        dispatch(
            setFilter({
                page: 1,
                pageSize: filter.pageSize,
                sortType: 1,
            }),
        );
    };

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(filter || {});
    }, [filter, form]);

    return (
        <Card
            size="small"
            className="expert-evaluation-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} onFinish={onFinish} form={form} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="任务" name="taskName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入任务关键字" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="级别" name="expertLevels" style={filterFormItemStyle}>
                            <Select mode="multiple" maxTagCount="responsive" allowClear options={expertLevels} fieldNames={{ label: 'label', value: 'level' }} placeholder="请选择专家级别" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="单位" name="unitName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入单位名称" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="项目名称" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="项目关键字或全称" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="姓名" name="memUsername" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入姓名" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="记录状态" name="status" style={filterFormItemStyle}>
                            <Select allowClear placeholder="请选择记录状态">
                                <Select.Option value={1}>未记录</Select.Option>
                                <Select.Option value={2}>已记录</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={onReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

export default EvaluationFilterForm;
